var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("ExplainCard", {
        attrs: {
          explainTitle: "商品竞品配置说明",
          explainText:
            "商品价格监控，同一竞品平台会有多个竞品商品或系统匹配的商品存在差异，需要手工配置或关联商品的竞品商品链接、SKU ID 等信息。列表只展示配置了监控规则的商品。",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "ivu-mt mt20",
          attrs: { bordered: false, shadow: "never" },
        },
        [
          _c(
            "el-form",
            {
              ref: "queryFormRef",
              attrs: {
                model: _vm.tableFrom,
                size: "small",
                inline: "",
                "label-width": "66px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品信息：", prop: "keywords" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入商品ID 或 名称",
                      size: "small",
                      clearable: "",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearchList($event)
                      },
                    },
                    model: {
                      value: _vm.tableFrom.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.tableFrom,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "tableFrom.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品规格：", prop: "specName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入商品规格",
                      size: "small",
                      clearable: "",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearchList($event)
                      },
                    },
                    model: {
                      value: _vm.tableFrom.specName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.tableFrom,
                          "specName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "tableFrom.specName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商户名称：", prop: "merId" } },
                [
                  _c("merchantName", {
                    attrs: { merIdChecked: _vm.tableFrom.merId },
                    on: { getMerId: _vm.getMerId },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品分类：", prop: "categoryId" } },
                [
                  _c("el-cascader", {
                    ref: "cascader",
                    attrs: {
                      clearable: "",
                      options: _vm.merPlatProductClassify,
                      props: _vm.categoryProps,
                      size: "small",
                    },
                    model: {
                      value: _vm.tableFrom.categoryId,
                      callback: function ($$v) {
                        _vm.$set(_vm.tableFrom, "categoryId", $$v)
                      },
                      expression: "tableFrom.categoryId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "竞品配置：", prop: "platformIds" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择竞品配置",
                        size: "small",
                        clearable: "",
                        multiple: "",
                      },
                      model: {
                        value: _vm.tableFrom.platformIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "platformIds", $$v)
                        },
                        expression: "tableFrom.platformIds",
                      },
                    },
                    _vm._l(_vm.platformIdsOptions, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleSearchList },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.resetSearchForm },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "tableRef",
                  attrs: {
                    data: _vm.tableData.data,
                    size: "small",
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      type: "index",
                      width: "50",
                      index: function (index) {
                        return (
                          (_vm.tableFrom.page - 1) * _vm.tableFrom.limit +
                          index +
                          1
                        )
                      },
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "originProductId",
                      label: "商品ID",
                      "min-width": "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "商品",
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "flex items-center" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "demo-image__preview line-heightOne mr10",
                                },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: scope.row.originProductImage,
                                      "preview-src-list": [
                                        scope.row.originProductImage,
                                      ],
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "text-overflow" }, [
                                _vm._v(_vm._s(scope.row.originProductName)),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "originSpecName",
                      label: "规格",
                      "min-width": "100",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brandName",
                      label: "品牌名称",
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      label: "商品分类",
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "merName",
                      label: "商户名称",
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "isShow",
                      label: "上架状态",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.isShow ? "上架" : "下架") +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "taobaoStatus",
                      label: "淘宝竞品状态",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jdStatus",
                      label: "京东竞品状态",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "140", fixed: "right" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["platform:competitor:config:get"],
                                    expression:
                                      "['platform:competitor:config:get']",
                                  },
                                ],
                                staticClass: "mr10",
                                on: {
                                  click: function ($event) {
                                    return _vm.openForm(
                                      "TB",
                                      scope.row.originProductId,
                                      scope.row.originSkuId
                                    )
                                  },
                                },
                              },
                              [_vm._v("淘宝配置")]
                            ),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["platform:competitor:config:get"],
                                    expression:
                                      "['platform:competitor:config:get']",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.openForm(
                                      "JD",
                                      scope.row.originProductId,
                                      scope.row.originSkuId
                                    )
                                  },
                                },
                              },
                              [_vm._v("京东配置")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "template",
                    { slot: "empty" },
                    [_c("el-empty", { attrs: { description: "暂无数据~" } })],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [10, 20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("CompetitionProductForm", {
        ref: "formRef",
        on: { success: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }